import type { MultiPolygon, Polygon } from 'geojson';

import type { IesRealtimeAlert } from '../types/realtime.types';

export function normalizeGatewayRealtimeAlertPayload(raw: unknown): IesRealtimeAlert | null {
  if (raw == null || typeof raw !== 'object') return null;
  const o = raw as Record<string, unknown>;
  const basinId =
    (typeof o.basinId === 'string' && o.basinId.trim()) ||
    (typeof o.basin_id === 'string' && o.basin_id.trim()) ||
    '';
  if (!basinId) return null;
  const level =
    (typeof o.level === 'string' && o.level.trim()) ||
    (typeof o.alert_level === 'string' && o.alert_level.trim()) ||
    'unknown';

  let geometry: Polygon | MultiPolygon | undefined;
  const geoRaw = o.geometry;
  if (geoRaw && typeof geoRaw === 'object') {
    const g = geoRaw as { type?: unknown };
    const t = g.type;
    if (t === 'Polygon' || t === 'MultiPolygon') {
      geometry = geoRaw as Polygon | MultiPolygon;
    }
  }

  return {
    basinId,
    level,
    ...(geometry ? { geometry } : {}),
    receivedAt: Date.now(),
  };
}
